import React from 'react';
import TagDetailsStep from './TagDetailsStep';
import FundInvestorTagApi from '../../../core/apis/FundInvestorTagApi';
import { memoize, isEmpty } from 'lodash';
import AssignTagStep from './assignTag/AssignTagStep';

export const STEP = {
  tagDetails: 'tagDetails',
  assignTag: 'assignTag'
};

export const listOfSteps = [
  {
    name: STEP.tagDetails,
    label: 'Tag Details',
    description: 'Set Tag Details and select Funds',
    component: TagDetailsStep
  },
  {
    name: STEP.assignTag,
    label: 'Assign Tag',
    description: 'Tick checkboxes to assign Tag for Fund-Investor Relationship',
    component: AssignTagStep
  }
];

export const GenerateMessageOnLeave = ({ name }) => (
  <p style={{ margin: 0 }}>
    You are about to quit the creation process and return to Fund-Investor Tag
    {!isEmpty(name) ? ` details ` : ` list `}
    screen.
    <br />
    Your progress on this step will not be saved.
    {!isEmpty(name) && (
      <p>
        <span style={{ fontWeight: 'bold' }}>{name} </span>
        has been created without Fund-Investor Relationships.
      </p>
    )}
  </p>
);

/**
 * Verify that Fund-Investor Tag name is unique
 */

// rff
export function validateFundInvestorTagNameRff(value) {
  return validateFundInvestorTagName(value);
}

const validateFundInvestorTagName = memoize(async name => {
  let error;
  const investorTagNameValid = !!name.trim();
  if (!investorTagNameValid) {
    error = `Fund Investor Tag Name can't be empty space(s)`;
  } else {
    try {
      const nameExists = await FundInvestorTagApi.checkIfNameExists(name);
      if (nameExists) {
        error = 'Fund Investor Tag Name already exists';
      }
    } catch (e) {
      error = 'Cannot validate name';
    }
  }
  return error;
});
